export const boardActionTypes = {
  SET_BOARD_LIST: 'SET_BOARD_LIST',
  SET_CURERNT_CONFIG: 'SET_CURERNT_CONFIG',
  SET_CURRENT_BOARD: 'SET_CURRENT_BOARD',
  SET_CURRENT_SETTING: 'SET_CURRENT_SETTING_ID',
  SET_PATTERN_LIST: 'SET_PATTERN_LIST',
  SET_SETTINGS_LIST: 'SET_SETTINGS_LIST',
};
